export const SET_MAP_DATA = "SET_MAP_DATA";
export const SET_CENTER_MAP = "SET_CENTER_MAP";
export const SET_LOADING_MAP = "SET_LOADING_MAP";
export const SET_GEOJSON_DATA = "SET_GEOJSON_DATA";
export const SET_MAP_SETTINGS = "SET_MAP_SETTINGS";
export const SET_LEGENDS_MAP = "SET_LEGENDS_MAP";
